import { Fragment, useState, useEffect } from 'react';

import { TableBody, TableCell, TableHead, TableRow, Button, TableContainer } from '@mui/material';

import { CustomTable } from 'esocial.web.react.lib/cjs/components/util/Table';
import { TituloPagina, TituloSecao } from 'esocial.web.react.lib/cjs/components/util/Text';
import { ContainerSecao, ContainerLateral, ContainerBotaoDireita } from 'esocial.web.react.lib/cjs/components/simples/Containers';

import { CelulaFonteMenor } from 'esocial.web.react.lib/cjs/components/simples/FormatacaoTabelas';
import { CampoTexto } from 'esocial.web.react.lib/cjs/components/simples/campos/CampoTexto';
import { CampoData } from 'esocial.web.react.lib/cjs/components/simples/campos/CampoData';
import { CampoComMascara, MascaraEnum } from 'esocial.web.react.lib/cjs/components/simples/campos/CampoComMascara';
import { SeletorOpcoes } from 'esocial.web.react.lib/cjs/components/simples/campos/SeletorOpcoes';

import { useRelatoriosGerenciaisContext } from '../../contexts/RelatoriosGerenciaisContext';
import { validarRelatorio, getConstantes } from './auxiliares/RelatoriosGerenciaisRequests';
import TextoColapsavel from './auxiliares/TextoColapsavel';

import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';

function isNullOrEmpty(variavel) {
    return variavel == null || variavel == '';
}

const IdentificadorGeral = () => {

    const { tipoInscricaoEmpregadorVal, setTipoInscricaoEmpregadorVal, numeroInscricaoEmpregadorVal, setNumeroInscricaoEmpregadorVal, chaveValidacao, setChaveValidacao,
        dataSolicitacaoRelatorio, setDataSolicitacaoRelatorio, setRelatorioVal, opcoesTipoInscricao } = useRelatoriosGerenciaisContext();

    const [isBuscarRelatorioBloqueado, setIsBuscarRelatorioBloqueado] = useState(true);
    useEffect(() => {
        setIsBuscarRelatorioBloqueado(isNullOrEmpty(tipoInscricaoEmpregadorVal) || isNullOrEmpty(numeroInscricaoEmpregadorVal)
            || isNullOrEmpty(dataSolicitacaoRelatorio) || isNullOrEmpty(chaveValidacao)
            || numeroInscricaoEmpregadorVal.replace(/[^a-zA-Z0-9]/g, '').length < 8)
    }, [tipoInscricaoEmpregadorVal, numeroInscricaoEmpregadorVal, chaveValidacao, dataSolicitacaoRelatorio])

    const dispatch = useAppDispatch();
    const tentaValidarRelatorio = () => {
        validarRelatorio(chaveValidacao, numeroInscricaoEmpregadorVal, tipoInscricaoEmpregadorVal, dataSolicitacaoRelatorio, setRelatorioVal, dispatch);
    }

    return (
        <ContainerSecao sx={{ gap: '1rem' }}>
            <CampoTexto
                label={'Chave de Validação'}
                variavel={chaveValidacao}
                obrigatorio={true}
                setVariavel={setChaveValidacao}
                flexGrow={1}
            />
            <ContainerLateral>
                <SeletorOpcoes
                    label={'Tipo empregador'}
                    obrigatorio={true}
                    variavel={tipoInscricaoEmpregadorVal}
                    setVariavel={setTipoInscricaoEmpregadorVal}
                    opcoes={opcoesTipoInscricao}
                />
                <CampoComMascara
                    mascaraTipo={tipoInscricaoEmpregadorVal == 1 ? MascaraEnum.CNPJ : MascaraEnum.CPF}
                    bloqueado={isNullOrEmpty(tipoInscricaoEmpregadorVal)}
                    obrigatorio={true}
                    label={'Número de inscrição'}
                    variavel={numeroInscricaoEmpregadorVal}
                    setVariavel={setNumeroInscricaoEmpregadorVal}
                    width={250}
                />
                <CampoData
                    label={'Data de Solicitação Relatório'}
                    variavel={dataSolicitacaoRelatorio}
                    obrigatorio={true}
                    setVariavel={setDataSolicitacaoRelatorio}
                    width={200}
                />
            </ContainerLateral>
            <ContainerBotaoDireita>
                <Button
                    aria-label={'validar relatório'}
                    variant="contained"
                    onClick={tentaValidarRelatorio}
                    color="primary"
                    disabled={isBuscarRelatorioBloqueado}
                    size="medium">
                    Validar relatório
                </Button>
            </ContainerBotaoDireita>
        </ContainerSecao>
    )
}

const RelatorioPedido = () => {

    const { relatorioVal, formatFiltro, formatDate, opcoesTipoRelatorio, opcoesTipoInscricao } = useRelatoriosGerenciaisContext();

    return (
        <TableContainer>
            <CustomTable>
                <TableHead id="tabela com relatório buscado" aria-label="tabela com relatório buscado">
                    <TableRow>
                        <TableCell align="center">Usuário Solicitante</TableCell>
                        <TableCell align="center">Inscrição Empregador</TableCell>
                        <TableCell align="center" size="small">Data Solicitação</TableCell>
                        <TableCell align="center" size="small">Data Informação</TableCell>
                        <TableCell align="center">Tipo de Relatório</TableCell>
                        <TableCell align="center">Filtros Aplicados</TableCell>
                        <TableCell align="center">Registros Recuperados</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {relatorioVal.length > 0 ?
                        (relatorioVal.map((linha) => {
                            return (
                                <TableRow key={linha.id}>
                                    <CelulaFonteMenor align="center">{linha.solicitante.numero}</CelulaFonteMenor>
                                    <CelulaFonteMenor align="center">{opcoesTipoInscricao.find(opcao => opcao.value === linha.empregador.tipo).label}: {linha.empregador.numero}</CelulaFonteMenor> {/* precisa da constante do tipo de inscricao*/}
                                    <CelulaFonteMenor align="center">{formatDate(linha.solicitacao)}</CelulaFonteMenor>
                                    <CelulaFonteMenor align="center">{formatDate(linha.informacao)}</CelulaFonteMenor>
                                    <CelulaFonteMenor align="center">{opcoesTipoRelatorio.find(tipo => tipo.value == linha.tipo).label}</CelulaFonteMenor>
                                    <CelulaFonteMenor align="left">
                                        <TextoColapsavel maxWidth={310}>
                                            {formatFiltro(linha.filtro)}
                                        </TextoColapsavel>
                                    </CelulaFonteMenor>
                                    <CelulaFonteMenor align="center">{linha.registrosRecuperados !== null ? linha.registrosRecuperados : '-'}</CelulaFonteMenor>
                                </TableRow>
                            )
                        })) : (
                            <TableRow>
                                <TableCell align="center" colSpan={9}>
                                    Nenhum relatório encontrado.
                                </TableCell>
                            </TableRow>
                        )
                    }
                </TableBody>
            </CustomTable>
        </TableContainer>
    )
}

const RelatoriosGerenciaisValidacao = () => {
    const { relatorioVal, setOpcoesTipoRelatorio, setOpcoesCBO, opcoesCBO,
        setOpcoesTipoEstabelecimento, setOpcoesCategorias, setDescricaoSituacao } = useRelatoriosGerenciaisContext();

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (opcoesCBO.length == 1) { //significa que não foi carregado
            getConstantes(setOpcoesTipoRelatorio, setDescricaoSituacao, setOpcoesTipoEstabelecimento, setOpcoesCBO, setOpcoesCategorias, dispatch);
        }
    }, []);

    return (
        <Fragment>
            <TituloPagina sx={{ color: '#5E7D61' }}>
                Relatórios Gerenciais - Validação
            </TituloPagina>
            <IdentificadorGeral />

            {relatorioVal &&
                <Fragment>
                    <TituloSecao>
                        Relatório Buscado
                    </TituloSecao>
                    <RelatorioPedido />
                </Fragment>
            }
        </Fragment>
    )
}

export default RelatoriosGerenciaisValidacao;
